import { useMemo } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";
import DurationServiceSingleton from "app/services/DurationService";
import { TitleContainerStyled } from "app/components/TrafficTopCountries/styles";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { translate } from "app/filters/i18nFilter";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";

export const TopPlayersWidgetTitle = () => {
    const { params } = useCurrentStateAndParams();
    const { from, to, compareFrom, compareTo } = useMemo(
        () => DurationServiceSingleton.getDurationData(params.duration, params.comparedDuration).forAPI,
        [params.duration, params.comparedDuration],
    );
    const subtitleFilters = [
        {
            filter: "date",
            value: { from, to, compareFrom, compareTo },
        },
    ];

    return (
        <TitleContainerStyled>
            <BoxTitle tooltip={translate("industry.research.market.performance.players.title.tooltip")}>
                {translate("industry.research.market.performance.players.title")}
            </BoxTitle>
            <StyledBoxSubtitle>
                <BoxSubtitle filters={subtitleFilters} />
            </StyledBoxSubtitle>
        </TitleContainerStyled>
    );
};
